import React from 'react';

const LogoSection = () => {
  return (
    <section className="relative py-20 bg-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-amber-400 rounded-full blur-3xl"></div>
        <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-amber-500 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center justify-center space-y-8">
          {/* Logo */}
          <div className="animate-fade-in">
            <img 
              src="/logo-gosmedia.webp" 
              alt="GOS MÉDIA - Studio Multimédia" 
              className="w-full max-w-2xl h-auto hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Optional tagline */}
          <div className="text-center animate-slide-up" style={{ animationDelay: '0.3s' }}>
            <p className="text-xl md:text-2xl text-gray-700 font-light max-w-3xl mx-auto">
              GO STUDIO MULTIMÉDIA
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSection;
